import 'core-js/stable';
import 'fast-text-encoding'; // Polyfill for TextEncoding, required for Edge browser
import 'underscore';
import 'intersection-observer';
import 'designSystemRuntime';
import { initializeSmartLink } from 'services/smartlink';
import { isWebpackRuntime } from 'tools/runtime-env';
import MyApp from './app';
import '@root/css/tailwind.css';

window.URL = window.URL || window.webkitURL;

function getParameterByName(
	name: string,
	url?: string,
) {
	if (!url) url = window.location.href;

	name = name.replace(
		/[[\]]/g,
		'\\$&',
	);
	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);

	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(
		/\+/g,
		' ',
	));
}

if (!(window.history && window.history.pushState)) {
	// IE9 (and other browsers without history support) deeplink workaround
	const rootPath = '/app';
	const location = `${window.location.protocol}//${window.location.hostname}${rootPath}`;
	const hash = window.location.hash.substr(1);

	let fragment = window.location.pathname.substr(rootPath.length + 1);

	if (fragment.length > 0 && hash.length > 0) {
		fragment += `&${hash}`;
	}
	if (fragment.length > 0) {
		window.location.href = `${location}#${fragment}`;
	}
}

// Set globals
const aid = getParameterByName('aid') || getParameterByName('_aid');
window.affiliateID = aid ? parseInt(
	aid,
	10,
) : 0;

const shopId = getParameterByName('shopid');
window.shopID = shopId ? parseInt(
	shopId,
	10,
) : null;

window.glAppUrl = BASE_URL ? `${BASE_URL}/` : `${window.location.protocol}//${window.location.host}/`;
window.glPlatform = window.webToNative ? 'native' : 'web';

if (window.glPlatform == 'native') {
	window.nativeToWeb = {};
}

window.glStack = STACK;

if (isWebpackRuntime()) {
	import('@lcdp/offline-plugin/runtime')
		.then((offlinePluginRuntime) => {
			offlinePluginRuntime.install({
				onInstalled: () => {
					console.log('ServiceWorker: installed');
				},
				onUpdateReady: () => {
					console.log('ServiceWorker: update ready');
					offlinePluginRuntime.applyUpdate();
				},
				onUpdated: () => {
					console.log('ServiceWorker: updated');
					window.swUpdate = true;
				},
				onUpdating: () => {
					console.log('ServiceWorker: downloading update');
				},
				onUpdateFailed: () => {
					/* Catch the failed update */
					console.log('ServiceWorker: update failed');
				},
			});
		})
		.catch(() => {
			/**
			 * Ignore runtime installation errors in environments where offline runtime
			 * is intentionally unavailable (for example Vite development).
			 */
		});
}

// TODO: Fix window.applicationCache type
if (
	window.glPlatform == 'native'
	// @ts-expect-error: `applicationCache` does exist in webView in the native iOS app
	&& window.applicationCache
) {
	const onAppCacheUpdate = () => {
		console.log('AppCache: updated');
		window.swUpdate = true;
	};

	// @ts-expect-error: `applicationCache` does exist in webView in the native iOS app
	if (window.applicationCache.status == window.applicationCache.UPDATEREADY) {
		onAppCacheUpdate();
	}

	// @ts-expect-error: `applicationCache` does exist in webView in the native iOS app
	window.applicationCache.addEventListener(
		'updateready',
		onAppCacheUpdate,
	);

	// @ts-expect-error: `applicationCache` does exist in webView in the native iOS app
	window.applicationCache.addEventListener(
		'downloading',
		() => { console.log('AppCache: downloading update'); },
	);

	// @ts-expect-error: `applicationCache` does exist in webView in the native iOS app
	window.applicationCache.addEventListener(
		'error',
		() => { console.log('AppCache: error during update'); },
	);

	window.setInterval(
		() => {
			/*
			 * Check for an application update every hour
			 */
			// @ts-expect-error: `applicationCache` does exist in webView in the native iOS app
			window.applicationCache.update();
		},
		60 * 60 * 1000,
	);
}

/**
 * Resolves launch attributes before constructing locale and authentication state.
 *
 * @returns Promise settled after the launch source has been loaded.
 */
async function startApp(): Promise<void> {
	await initializeSmartLink();
	window.App = new MyApp();
	window.App.start();
}

void startApp();
